"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export function BannerSection() {
  const containerRef = useRef<HTMLElement>(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  // Line 1 moves right → left as user scrolls through
  const line1X = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ["50%", "0%", "-50%"]
  );
  // Line 2 moves left → right
  const line2X = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ["-50%", "0%", "50%"]
  );

  return (
    <section
      className="relative w-full overflow-hidden bg-background py-16 sm:py-24 md:py-32"
      ref={containerRef}
    >
      <div className="flex flex-col items-center justify-center gap-4 sm:gap-6 md:gap-8">
        <div className="flex w-full justify-center py-2 sm:py-3 md:py-4">
          <motion.div
            className="whitespace-nowrap px-4"
            style={{ x: line1X, willChange: "transform" }}
          >
            <p className="font-medium font-serif text-3xl italic sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl">
              Expanding a Culture of Recovery
            </p>
          </motion.div>
        </div>

        <div className="flex w-full justify-center py-2 sm:py-3 md:py-4">
          <motion.div
            className="whitespace-nowrap px-4"
            style={{ x: line2X, willChange: "transform" }}
          >
            <p className="font-medium font-serif text-3xl italic sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl">
              No One Should Be Left Behind
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
